<template>
  <div class="weight-visualizer">
    <!-- Donut Chart -->
    <svg 
      :width="donutSize" 
      :height="donutSize" 
      class="donut-chart"
      viewBox="0 0 100 100"
    >
      <!-- Background circle -->
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        stroke="hsl(var(--b3))"
        stroke-width="12"
      />
      
      <!-- Stock segments -->
      <path
        v-for="(stock, index) in stocks"
        :key="stock.symbol"
        :d="getArcPath(stock.weight, getStartAngle(index))"
        fill="none"
        :stroke="getColor(index)"
        stroke-width="12"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  stocks: {
    type: Array,
    required: true,
    default: () => []
  }
})

// Donut chart size
const donutSize = 60

// Color palette for different stocks
const colors = [
  '#3B82F6', // Blue
  '#EF4444', // Red
  '#10B981', // Green
  '#F59E0B', // Yellow
  '#8B5CF6', // Purple
  '#F97316', // Orange
  '#06B6D4', // Cyan
  '#EC4899', // Pink
  '#84CC16', // Lime
  '#6366F1', // Indigo
]

const getColor = (index) => {
  return colors[index % colors.length]
}

// Calculate start angle for each segment
const getStartAngle = (index) => {
  let angle = -90 // Start from top
  for (let i = 0; i < index; i++) {
    angle += (props.stocks[i].weight || 0) * 360
  }
  return angle
}

// Generate SVG path for arc segment
const getArcPath = (weight, startAngle) => {
  if (!weight || weight <= 0) return ''
  
  const radius = 40
  const centerX = 50
  const centerY = 50
  
  const startRad = (startAngle * Math.PI) / 180
  const endRad = ((startAngle + weight * 360) * Math.PI) / 180
  
  const startX = centerX + radius * Math.cos(startRad)
  const startY = centerY + radius * Math.sin(startRad)
  const endX = centerX + radius * Math.cos(endRad)
  const endY = centerY + radius * Math.sin(endRad)
  
  const largeArcFlag = weight > 0.5 ? 1 : 0
  
  return `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`
}
</script>

<style scoped>
.weight-visualizer {
  flex-shrink: 0;
}

.donut-chart {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}
</style> 